import React from 'react';
import { Plus, Trash2, BarChart3, Sparkles } from 'lucide-react';
import { PageSection } from '../../../../types';

interface StatsEditorProps {
  section: PageSection;
  onUpdateContent: (updates: any) => void;
}

export const StatsEditor: React.FC<StatsEditorProps> = ({ section, onUpdateContent }) => {
  const content = section.content || {};
  const items: any[] = content.items || [
    { value: '150+', label: 'Tamamlanan Proje' },
    { value: '%99.4', label: 'Müşteri Memnuniyeti' },
    { value: '25+', label: 'Yıllık Deneyim' },
    { value: '7/24', label: 'Operasyonel Destek' },
  ];

  const handleUpdateItem = (index: number, updates: any) => {
    const next = [...items];
    next[index] = { ...next[index], ...updates };
    onUpdateContent({ items: next });
  };

  const handleAddItem = () => {
    const next = [...items, { value: '100+', label: 'Yeni Metrik' }];
    onUpdateContent({ items: next });
  };

  const handleDeleteItem = (index: number) => {
    const next = items.filter((_, i) => i !== index);
    onUpdateContent({ items: next });
  };

  return (
    <div className="space-y-6">
      {/* Headings */}
      <div className="p-4 rounded-2xl bg-slate-800/40 border border-slate-700/60 space-y-3.5">
        <div className="flex items-center gap-2">
          <Sparkles className="w-3.5 h-3.5 text-blue-400" />
          <h4 className="text-xs font-bold text-slate-200">İstatistik Başlıkları</h4>
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Üst Rozet</label>
          <input
            type="text"
            value={content.badge ?? 'RAKAMLARLA BİZ'}
            onChange={(e) => onUpdateContent({ badge: e.target.value })}
            className="w-full bg-slate-900 border border-slate-700 text-xs font-semibold text-slate-200 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Ana Başlık</label>
          <input
            type="text"
            value={content.title ?? 'Başarı ve Güven Dolu Yolculuk'}
            onChange={(e) => onUpdateContent({ title: e.target.value })}
            className="w-full bg-slate-900 border border-slate-700 text-xs font-bold text-slate-100 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>
      </div>

      {/* Stats items */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <BarChart3 className="w-4 h-4 text-blue-400" />
            <h4 className="text-xs font-extrabold text-slate-200">Metrikler ({items.length})</h4>
          </div>
          <button
            type="button"
            onClick={handleAddItem}
            className="px-2.5 py-1.5 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-[11px] font-bold flex items-center gap-1.5 shadow-sm transition"
          >
            <Plus className="w-3.5 h-3.5" />
            <span>Metrik Ekle</span>
          </button>
        </div>

        <div className="space-y-2">
          {items.map((item, idx) => (
            <div key={idx} className="p-3 rounded-2xl bg-slate-800/40 border border-slate-700/60 flex items-center gap-3">
              <input
                type="text"
                value={item.value || ''}
                onChange={(e) => handleUpdateItem(idx, { value: e.target.value })}
                placeholder="100+"
                className="w-24 bg-slate-900 border border-slate-700 text-sm font-black text-blue-400 px-3 py-2 rounded-xl outline-none text-center focus:border-blue-500"
              />
              <input
                type="text"
                value={item.label || ''}
                onChange={(e) => handleUpdateItem(idx, { label: e.target.value })}
                placeholder="Açıklama etiketi..."
                className="flex-1 bg-slate-900 border border-slate-700 text-xs font-semibold text-slate-200 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
              />
              <button
                type="button"
                onClick={() => handleDeleteItem(idx)}
                className="p-2 text-slate-500 hover:text-rose-400 transition"
              >
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
